import { useSelector } from "react-redux";

import { SlideStack } from "@intelligems/ig-theme/animation/SlideStack";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { useBasicModPanels } from "@src/features/experienceBuilder/modifications/basicMods/useBasicModPanels";
import { useComponentPanels } from "@src/features/experienceBuilder/modifications/components/useComponentPanels";
import { ModificationEmptyState } from "@src/features/experienceBuilder/modifications/emptyState/ModificationEmptyState";
import { ModificationsList } from "@src/features/experienceBuilder/modifications/ModificationsList";

import { ExperienceBuilderAiSelector } from "@src/store/slices/experienceBuilder/ai";
import { ExperienceBuilderSelector } from "@src/store/slices/experienceBuilder";

export const ModificationsPanel = () => {
  const hasMods = useSelector(ExperienceBuilderSelector.hasVariationMods);
  const basicModPanels = useBasicModPanels();
  const componentPanels = useComponentPanels();
  const isAiBusy = useSelector(ExperienceBuilderAiSelector.getIsAiBusy);

  // The same key for both base components is intentional
  // We don't want animations when switching between them
  return (
    <Stack sx={{ position: "relative", height: "100%", minHeight: 0 }}>
      <SlideStack direction={"left"}>
        {hasMods ? (
          <ModificationsList key="list" />
        ) : (
          <ModificationEmptyState key="list" />
        )}
        {basicModPanels}
        {componentPanels}
      </SlideStack>
      {isAiBusy && (
        // Transparent click-blocker so the user can SEE the current mod
        // state while AI is mid-turn but can't edit/delete/copy mods
        // (which would race the AI's mental model of what's there).
        // The chat's Stop button is the escape hatch.
        <Box
          aria-label="AI is busy, please wait..."
          sx={{
            position: "absolute",
            inset: 0,
            zIndex: 10,
            cursor: "not-allowed",
            // Faint tint signals "this is locked, not just empty space".
            backgroundColor: "rgba(255, 255, 255, 0.4)",
          }}
        />
      )}
    </Stack>
  );
};
